export const SET_ANON_ID = 'frontend/anonymous/SET_ANON_ID';

export function setAnonId(anonId) {
  return { type: SET_ANON_ID, payload: anonId };
}
